module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value": _vm.value,
      "name": _vm.name,
      "type": _vm.type,
      "placeholder": _vm.format,
      "value-format": _vm.format,
      "format": _vm.format,
      "picker-options": _vm.handleDateOptions,
      "clearable": _vm.clearable,
      "disabled": _vm.disabled,
      "rules": _vm.rules
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      },
      "keydown": function($event) {
        return _vm.$emit('keydown', $event)
      },
      "keyup": function($event) {
        return _vm.$emit('keyup', $event)
      },
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f7afce7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdInputDate.vue
// module id = 1445
// module chunks = 45